"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifySession = verifySession;
const client_1 = require("../../session/client/index.js");
async function verifySession() {
    const headers = {};
    const sessionId = (0, client_1.getRuntimeSessionId)();
    if (sessionId) {
        headers.Authorization = `Bearer ${sessionId}`;
    }
    const response = await fetch("/api/sessions", {
        headers,
        credentials: "include",
    });
    return response.ok;
}
